import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_institute_target_change_summery",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "target_change_summery",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_institute_target_change_summery_button",
  "data-kt-drawer-close": "#kt_drawer_institute_target_change_summery_close",
  "data-kt-drawer-width": "50vw"
}
const _hoisted_2 = {
  id: "kt_target_change_summery",
  class: "card shadow-none border-0",
  style: {"width":"72.5vw"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header bg-primary text-light\" id=\"kt_target_change_summery_header\"><h2 class=\"fw-bolder text-light\">Institute Target Info</h2><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-sm btn-icon btn-active-primary-light me-n5\" id=\"kt_drawer_institute_target_change_summery_close\"><i class=\"fas fa-times text-light\"></i></button></div></div>", 1)
const _hoisted_4 = {
  class: "card-body position-relative",
  id: "kt_target_change_summery_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_target_change_summery_body",
  "data-kt-scroll-dependencies": "#kt_target_change_summery_header, #kt_target_change_summery_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_5 = { class: "position-relative" }
const _hoisted_6 = { class: "card-body p-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder container m-0 text-primary border-bottom border-2 py-4 pl-0" }, " Training Target Change Summery ", -1)
const _hoisted_8 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_target_change_summery_scroll"
}
const _hoisted_9 = {
  class: "table table table-borderless",
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", {
    class: "bg-secondary",
    style: {"border":"1px solid #1db78d"}
  }, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Column Name"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Old Data"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "New Data")
  ])
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, "Trainee Target", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("table", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_11,
                    _createElementVNode("td", null, _toDisplayString(this.formData.total_target_trainee), 1),
                    _createElementVNode("td", null, _toDisplayString(this.newData), 1)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}